import React from 'react';
import { Button, Form, Row, Col } from 'antd';
import { InputField, SelectField } from 'Atoms/FormElement';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useTranslate } from 'Translate';

export default (props) => {
  const { locations } = useSelector((state) => state.outlet.outletsMeta);
  const { searchVal } = props;
  const { control, handleSubmit } = useForm()
  const i18n = useTranslate();
  const { t } = i18n;

  const locationOptions = locations?.map(loc => ({label: `${loc.code} ${loc.desc}`, value: loc.id}))

  const onSubmit = (val) => {
    props.onSearch(val);
  }

  return (
    <Form onFinish={handleSubmit(onSubmit)} layout="inline" className='w-100 inline-form'>
      <Row className='w-100' gutter={[10, 10]}>
        <Col flex="auto">
          <InputField
            fieldname='code'
            label=''
            class='mb-0 w-100'
            initValue={searchVal?.code ? searchVal?.code : ''}
            control={control}
            iProps={{ placeholder: `${t("General.search_by_code")}..` }}
          />
        </Col>
        <Col flex="auto">
          <SelectField
            fieldname='name'
            label=''
            class='mb-0 w-100 default-select'
            control={control}
            iProps={{ placeholder: t("General.outlet") }}
            selectOption={locationOptions}
          />
        </Col>
        <Col flex="auto">
          <InputField
            fieldname='group'
            label=''
            class='mb-0 w-100'
            initValue={searchVal?.group ? searchVal?.group : ''}
            control={control}
            iProps={{ placeholder: `${t("General.search_by_outlet_group_code")}..` }}
          />
        </Col>
        <Col flex="auto">
          <InputField
            fieldname='menu'
            label=''
            class='mb-0 w-100'
            initValue={searchVal?.menu ? searchVal?.menu : ''}
            control={control}
            iProps={{ placeholder: `${t("General.search_by_product_menu_code")}..` }}
          />
        </Col>
        <Col flex="70px">
          <Button className='w-100' size='large' type='primary' htmlType='submit'>{t("General.search")}</Button>
        </Col>
      </Row>
    </Form>
  )
}